import { createFileRoute } from "@tanstack/react-router";

import { BillingLandingPanel } from "../../../workspaces/settings/BillingLandingPanel";

export const Route = createFileRoute("/_console/settings/billing")({
  component: BillingLandingPanel,
});
